import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import type { LoginBody, SessionResponse } from '@lira/shared';
import { ApiError, apiPost } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';
import { AuthCard, AuthField, AuthSubmit } from './AuthCard';

/** Tela de login — e-mail + senha, fora do AppShell. */
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const setSession = useAuthStore((s) => s.setSession);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setLoading(true);
    try {
      const body: LoginBody = { email: email.trim().toLowerCase(), password };
      const { accessToken, user } = await apiPost<SessionResponse>('/auth/login', body);
      setSession(accessToken, user);
      const from =
        (location.state as { from?: { pathname?: string } } | null)?.from?.pathname ?? '/';
      navigate(from, { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : 'Não foi possível entrar. Tente novamente.',
      );
      setLoading(false);
    }
  };

  return (
    <AuthCard>
      <form onSubmit={(e) => void handleSubmit(e)} className="mt-8 space-y-4" noValidate>
        <AuthField
          label="E-mail"
          id="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <AuthField
          label="Senha"
          id="password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p className="text-sm text-expense">{error}</p>}

        <AuthSubmit loading={loading}>ENTRAR</AuthSubmit>
      </form>

      <p className="mt-6 text-center text-sm text-muted">
        Ainda não tem conta?{' '}
        <Link to="/registro" className="font-medium text-primary hover:underline">
          Criar conta
        </Link>
      </p>
    </AuthCard>
  );
}
